import axios from "axios";

const MWI = "MWI";
const ESHELF = "ESHELF";
const VICTOR = "VICTOR";
// const VETCOVE = "VETCOVE";

function defaultState() {
    return {
        orderIndex: null,
        orderId: null,
        isLoading: true,
        isLoadingReceipts: false,
        isLoadingItems: false,
        isLoadingShipping: false,
        isSavingEdit: false,
        sourceCatalog: null,
        details: {
            supplier: "-",
            supplierEncodedId: "-",
            date: "-",
            accountNumber: "-",
            shipTo: "-",
            billTo: "-",
            status: "-",
            items: 0,
            shipping: 0,
            total: 0,
            notes: "-"
        },
        isEditMode: false,
        isLodingAddress: false,
        editDetails: {},
        items: [],
        shipping: [],
        receipts: [],
        address: [],
        supplier: {},
        itemCurrentPage: 1,
        itemLastPage: 1,
        totalItems: 0,
        itemPerPage: 50
    };
}

const state = defaultState();

const actions = {
    async fetchDetails({ commit }, payload) {
        function loading(bool) {
            commit("setLoader", { key: "isLoading", value: bool });
        }

        loading(true);

        let res = await axios.get(
            `${process.env.BARRAMUNDI}inventory/order/${payload.orderId}`
        );

        let response = res.data.response;

        if (response && response.resources) {
            let resources = response.resources;
            let supplier = resources.supplier || {};
            let shipTo = "-";
            let billTo = "-";
            let statusLabel = resources.status_label;

            switch (resources.source_catalog) {
                case MWI:
                    billTo = "Default to MWI Address";
                    shipTo = "Default to MWI Address";
                    statusLabel = `${statusLabel} (${resources.mwi_order_name})`;
                    break;

                case VICTOR:
                    billTo = "Default to Victor Address";
                    shipTo = "Default to Victor Address";
                    break;

                default:
                    if (resources.bill_to_address) {
                        billTo = resources.bill_to_address.name;
                    }

                    if (resources.ship_to_address) {
                        shipTo = resources.ship_to_address.name;
                    }
                    break;
            }

            commit("setDetails", {
                supplier: supplier.name || "-",
                supplierEncodedId: supplier.encoded_id,
                accountNumber: resources.account_no || "-",
                date: resources.order_date,
                shipTo: shipTo,
                shipToId: resources.ship_to_id,
                billTo: billTo,
                billToId: resources.bill_to_id,
                status: resources.status,
                statusLabel: statusLabel,
                items: resources.sub_total || 0,
                total: resources.total || 0,
                shipping: resources.shipping || 0,
                notes: resources.notes
            });

            commit("setSourceCatalog", resources.source_catalog);
            commit("setOrderId", payload.orderId);
            commit("setOrderIndex", resources.index);
            commit("setSupplierInfo", resources.supplier);

            loading(false);
        } else {
            loading(false);
            throw new Error("Unable to fetch order details.");
        }
    },
    async fetchItems({ commit, dispatch }, payload) {
        function loading(bool) {
            commit("setLoader", { key: "isLoadingItems", value: bool });
        }

        loading(true);

        let res = await axios.get(
            `${process.env.BARRAMUNDI}inventory/order/item/list/${payload.orderId}?page=${payload.page || 1}` // prettier-ignore
        );

        let response = res.data.response;

        if (
            response &&
            response.message &&
            response.message.code === 200 &&
            response.resources
        ) {
            commit("setItems", response.resources.data);

            commit("setPageInfo", {
                itemCurrentPage: response.resources.current_page,
                itemLastPage: response.resources.last_page,
                totalItems: response.resources.total,
                itemPerPage: response.resources.per_page
            });

            loading(false);

            // reload details if necessary, eg: to update total
            if (payload.reloadDetails) {
                dispatch("fetchDetails", {
                    orderId: payload.orderId
                });
            }
        } else {
            loading(false);
            commit("setItems", []);
            throw new Error("Unable to fetch items.");
        }
    },
    async fetchReceipts({ commit }, payload) {
        function loading(bool) {
            commit("setLoader", { key: "isLoadingReceipts", value: bool });
        }

        loading(true);

        let res = await axios.get(
            `${process.env.BARRAMUNDI}inventory/receipt`,
            {
                params: {
                    purchase_order_id: payload.orderId,
                    status: "all",
                    page: 1
                }
            }
        );

        let response = res.data.response;

        if (response && response.message && response.message.code === 200) {
            commit("setReceipts", response.resources);
            loading(false);
        } else {
            loading(false);
            commit("setReceipts", []);
            throw new Error("Unable to fetch receipts.");
        }
    },
    async fetchShipping({ commit }, payload) {
        function loading(bool) {
            commit("setLoader", { key: "isLoadingShipping", value: bool });
        }

        loading(true);

        let res = await axios.get(
            `${process.env.BARRAMUNDI}inventory/order/item/shipping/${payload.orderId}`
        );

        let response = res.data.response;

        if (response && response.message && response.message.code === 200) {
            commit("setShipping", response.resources);
            loading(false);
        } else {
            loading(false);
            commit("setShipping", []);
            throw new Error("Unable to fetch receipts.");
        }
    },
    async editOrder({ commit }) {
        commit("initEditOrder");

        function loading(bool) {
            commit("setLoader", { key: "isLoadingAddress", value: bool });
        }

        loading(true); // get address list

        let res = await axios.get(
            `${process.env.BARRAMUNDI}inventory/address/list`
        );

        if (res.data.response && res.data.response.resources) {
            let address = [];

            for (let id in res.data.response.resources) {
                address.push({
                    value: id,
                    label: res.data.response.resources[id]
                });
            }

            commit("setAddressList", address);
            loading(false);
        } else {
            loading(false);
            commit("setAddressList", []);
            throw new Error("Unable to fetch address list");
        }
    },
    async saveEdit({ state, commit }, payload) {
        function loading(bool) {
            commit("setLoader", { key: "isSavingEdit", value: bool });
        }

        let { accountNumber, notes, shipToId, billToId } = state.editDetails;

        loading(true);

        let res = await axios.put(
            `${process.env.BARRAMUNDI}inventory/order/${state.orderId}`,
            {
                account_no: accountNumber,
                order_date: payload.dateUnix,
                ship_to_id: shipToId,
                bill_to_id: billToId,
                notes: notes
            }
        );

        loading(false);

        if (
            res.data.response &&
            res.data.response.message &&
            res.data.response.message.code === 200
        ) {
            const getAddress = (id = "") => {
                let address = state.address.find(
                    add => add.value === id.toString()
                );

                return address ? address.label : "-";
            };

            let resources = res.data.response.resources;

            switch (state.sourceCatalog) {
                case MWI:
                case VICTOR:
                    commit("updateDetails", {
                        date: resources.order_date,
                        notes: resources.notes
                    });
                    break;

                case ESHELF:
                    commit("updateDetails", {
                        date: resources.order_date,
                        notes: resources.notes,
                        shipTo: getAddress(resources.ship_to_id),
                        shipToId: resources.ship_to_id,
                        billTo: getAddress(resources.bill_to_id),
                        billToId: resources.bill_to_id
                    });
                    break;

                default:
                    commit("updateDetails", {
                        accountNumber: resources.account_no,
                        date: resources.order_date,
                        notes: resources.notes,
                        shipTo: resources.ship_to_id
                            ? getAddress(resources.ship_to_id)
                            : "",
                        shipToId: resources.ship_to_id,
                        billTo: resources.bill_to_id
                            ? getAddress(resources.bill_to_id)
                            : "",
                        billToId: resources.bill_to_id
                    });
                    break;
            }
        } else {
            throw new Error("Unable to update order.");
        }
    },
    async submitOrder({ state }, payload) {
        let res = await axios.post(
            `${process.env.BARRAMUNDI}inventory/order/submit-order`,
            {
                purchase_order_id: payload.orderId
            }
        );

        let response = res.data.response;

        if (response && response.message && response.message.code === 200) {
            return true;
        } else {
            if (response.catalog === MWI) {
                throw new Error(response.message.errors);
            } else {
                throw new Error("Unable to submit order.");
            }
        }
    }
};

const mutations = {
    updateDetails(state, payload = {}) {
        let newDetails = {
            ...state.details,
            ...payload
        };

        state.details = newDetails;
        state.isEditMode = false;
    },
    initEditOrder(state) {
        state.isEditMode = true;
        state.editDetails = { ...state.details }; // clone
    },
    setLoader(state, { key, value }) {
        state[key] = value;
    },
    setOrderIndex(state, value) {
        state.orderIndex = value;
    },
    setOrderId(state, value) {
        state.orderId = value;
    },
    setSourceCatalog(state, value) {
        state.sourceCatalog = value;
    },
    setDetails(state, value) {
        state.details = value;
    },
    setReceipts(state, value) {
        state.receipts = value;
    },
    setShipping(state, value) {
        state.shipping = value;
    },
    setItems(state, value) {
        state.items = value;
    },
    setPageInfo(state, payload) {
        state.itemCurrentPage = payload.itemCurrentPage;
        state.itemLastPage = payload.itemLastPage;
        state.totalItems = payload.totalItems;
        state.itemPerPage = payload.itemPerPage;
    },
    setCurrentPage(state, value) {
        state.itemCurrentPage = value;
    },
    setEditDetails(state, value) {
        state.editDetails = value;
    },
    setEditDetailsDate(state, value) {
        state.editDetails.date = value;
    },
    setEditDetailsKey(state, { key, value }) {
        state.editDetails[key] = value;
    },
    cancelEdit(state) {
        state.isEditMode = false;
        state.editDetails = {};
    },
    setAddressList(state, value) {
        state.address = value;
    },
    setSupplierInfo(state, value) {
        state.supplier = value;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
